import styles from './Skeleton.module.scss';

interface SkeletonProps {
  /**
   * 스켈레톤의 모양을 지정합니다. 'circle', 'rectangle', 'round' 중 하나를 선택할 수 있습니다.
   * 기본값은 'rectangle'입니다.
   */
  shape?: 'circle' | 'rectangle' | 'round';
  /**
   * 스켈레톤의 너비를 지정합니다. 기본값은 '100%'입니다.
   * 'auto'로 설정하면 콘텐츠에 맞게 자동으로 조정됩니다.
   */
  width?: string | number;
  /**
   * 스켈레톤의 높이를 지정합니다. 기본값은 '20px'입니다.
   * 'auto'로 설정하면 콘텐츠에 맞게 자동으로 조정됩니다.
   */
  height?: string | number;
  /**
   * 스켈레톤 애니메이션 효과를 지정합니다. 'glow' 또는 'blink' 중 하나를 선택할 수 있습니다.
   * 기본값은 'glow'입니다.
   */
  animation?: 'glow' | 'blink';
}

/**
 * 스켈레톤 컴포넌트는 로딩 상태를 나타내기 위해 사용됩니다.
 * 다양한 모양과 크기를 지원하며, 애니메이션 효과를 적용할 수 있습니다.
 */
export default function Skeleton({ shape, width, height, animation = 'glow' }: SkeletonProps) {
  const animationClass = animation === 'glow' ? styles['skeleton--glow'] : styles['skeleton--blink'];

  if (shape === 'circle') {
    return (
      <div className={`${styles['skeleton-circle']} ${animationClass}`} style={{ width, height }} />
    );
  }

  if (shape === 'round') {
    return (
      <div className={`${styles['skeleton-round']} ${animationClass}`} style={{ width, height }} />
    );
  }

  return (
    <div className={`${styles['skeleton-rectangle']} ${animationClass}`} style={{ width, height }} />
  );
}